import { DateRangePicker } from '@/components/filters/DateRangePicker'
import { FilterBar, FilterField } from '@/components/filters/FilterBar'
import { MonthPicker } from '@/components/filters/MonthPicker'
import { OptionSelect } from '@/components/filters/OptionSelect'
import { BOOLEAN_OPTIONS, DistinctMultiSelect } from '@/features/report/ReportFilterBar'
import type { ReportFilters } from '@/features/report/use-report-filters'
import { messages } from '@/lib/messages'
import type { DocumentFilter } from '@/services/cube/document'

/**
 * Önizleme verisi için dönem ve şablonda tanımlı filtreler (durum adreste; kopya üretiminde
 * D7 aynı değerleri kullanır). `period` adreste mutlak `YYYY-MM`'dir.
 */
export function PreviewFilters({
  filters,
  reportFilters,
}: {
  filters: DocumentFilter[]
  reportFilters: ReportFilters
}) {
  const { state, update, period } = reportFilters
  if (filters.length === 0) return null
  return (
    <FilterBar onReset={reportFilters.reset}>
      {filters.map((filter) => {
        const key = `${filter.view}.${filter.member}`
        switch (filter.type) {
          case 'period':
            return (
              <FilterField
                key={key}
                label={messages.documents.editor.previewPeriod}
                htmlFor="preview-period"
              >
                <MonthPicker
                  id="preview-period"
                  value={period}
                  onChange={(value) => update({ [filter.member]: value })}
                />
              </FilterField>
            )
          case 'multiSelect':
            return (
              <DistinctMultiSelect
                key={key}
                view={filter.view}
                member={key}
                label={filter.member}
                selected={state.multi[key] ?? []}
                onChange={(values) => update({ [filter.member]: values })}
              />
            )
          case 'boolean': {
            const value = state.bool[key]
            return (
              <FilterField key={key} label={filter.member}>
                <OptionSelect
                  aria-label={filter.member}
                  className="w-44"
                  value={value === undefined ? '' : String(value)}
                  options={BOOLEAN_OPTIONS}
                  onValueChange={(next) => update({ [filter.member]: next || undefined })}
                />
              </FilterField>
            )
          }
          case 'dateRange':
            return (
              <DateRangePicker
                key={key}
                idPrefix="preview"
                from={state.dateFrom}
                to={state.dateTo}
                defaultRange={typeof filter.default === 'string' ? filter.default : undefined}
                onChange={({ from, to }) => update({ date_from: from, date_to: to })}
              />
            )
        }
      })}
    </FilterBar>
  )
}
